export default "__VITE_ASSET__X3E4BSwR__"